import React, { useContext, useEffect, useState } from 'react';
import styles from './PostPreviews.module.scss';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faHeart, faUser, faCalendar } from '@fortawesome/free-regular-svg-icons';
import routes from '~/configs';
import { BASE_URL_IMG, postData } from '~/helper/apiService';
import Controller from '../Controller';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import EditPost from '../EditPost';
import ConfirmModal from '../ConfirmModal';
import { FetchDataContext } from '../Context/FetchDataProvider';
import { ToastContext } from '../Context/ToastProvider';
import { LoginContext } from '../Context/LoginProvider';

const cx = classNames.bind(styles);

function PostPreviews({ post, handleLike }) {
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const { loadPosts } = useContext(FetchDataContext);
  const { addToast } = useContext(ToastContext);
  const { loginStatus } = useContext(LoginContext);
  const [like, setLike] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleEdit = (e) => {
    e.preventDefault();
    setModalComponentContent(<EditPost id={post.id} />);
  };

  const handleConfirmDelete = async () => {
    const formData = new FormData();
    formData.append('id', post.id);
    const res = await postData('/post/delete', formData);
    if (res.status === 'success') {
      loadPosts();
      setModalComponentContent(null);
    } else {
      addToast(res);
    }
  };

  const handleCancelDelete = () => {
    setModalComponentContent(null);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setModalComponentContent(
      <ConfirmModal
        title="Xác nhận xóa bài viết"
        handleConfirm={handleConfirmDelete}
        handleCancel={handleCancelDelete}
      />,
    );
  };

  if (!handleLike) {
    handleLike = async () => {
      const formData = new FormData();
      formData.append('id', post.id);
      const res = await postData('/post/like', formData);
      if (res.status === 'success') {
        setLike((prev) => prev + 1);
      } else {
        addToast(res);
      }
    };
  }

  useEffect(() => {
    setLike(post.likes);
  }, [post]);

  return (
    <div className={cx('post')} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {loginStatus && (
        <Controller
          className={cx('controller', { show: isHovered })}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      )}

      <div className={cx('post-content')}>
        {post.img && (
          <div className={cx('post-image-wrapper')}>
            {!imageLoaded && <div className={cx('image-skeleton')} />}
            <img
              src={BASE_URL_IMG + '/' + post.img}
              alt="Post"
              className={cx('post-image', { loaded: imageLoaded })}
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
            />
          </div>
        )}

        <div className={cx('post-details')}>
          <div to={`${routes.postDetail}/${post.id}`} className={cx('post-nav')}>
            <h2 className={cx('post-title')}>{post.title}</h2>
            <p className={cx('post-content')}>{post.content}</p>
          </div>

          <div className={cx('post-meta')}>
            <div className={cx('post-meta-box')}>
              <button className={cx('interaction-btn')} onClick={handleLike}>
                <FontAwesomeIcon className={cx('icon')} icon={faHeart} />
                <span className={cx('text')}>{like}</span>
              </button>
              <button className={cx('interaction-btn')}>
                <FontAwesomeIcon className={cx('icon')} icon={faComment} />
                <span className={cx('text')}>{post.comment_count}</span>
              </button>
            </div>

            <div className={cx('post-info')}>
              {/* <div className={cx('author-info')}>
                <FontAwesomeIcon className={cx('icon')} icon={faUser} />
                <span className={cx('text')}>Quyen</span>
              </div> */}
              <div className={cx('date-info')}>
                <FontAwesomeIcon className={cx('icon')} icon={faCalendar} />
                <span className={cx('text')}>{post.date_create}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostPreviews;
